module.exports = __webpack_public_path__ + "static/media/olho-magico.5254ef7d.jpg";